import i18n from '@/plugins/i18n'

export const formatDate = (date?: Date | string | null, showYear?: boolean, locale: 'en' | 'de' = 'de') => {
  if (!date) return '-'
  const d = new Date(date)
  return `${d.toLocaleString(locale, { month: 'long' })} ${d.getDate()}${showYear ? ', ' + d.toLocaleString(locale, { year: 'numeric' }) : ''}`
}

export const formatDateToDay = (date?: Date | string | null) => {
  if (!date) return '-'
  const d = new Date(date)
  return d.toLocaleString('default', { weekday: 'long' })
}

export const formatPrice = (amount?: number | null, locale: 'en' | 'de' = 'de', showFreeAsText?: boolean): string => {
  if (amount == null || (amount == 0 && showFreeAsText)) {
    return i18n.global.t('common.forFree', {}, { locale }) as string
  }

  const formatter = new Intl.NumberFormat(locale === 'de' ? 'de-DE' : 'en-US', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })

  const parts = formatter.formatToParts(amount)

  const number = parts
    .filter((p) => p.type !== 'currency')
    .map((p) => p.value)
    .join('')

  if (locale === 'en') {
    return `€ ${number}`
  }

  return `${number}€`
}

export const formatPriceRange = (min: number, max: number, locale: 'en' | 'de' = 'de', showFreeAsText?: boolean): string => {
  const formatter = new Intl.NumberFormat(locale === 'de' ? 'de-DE' : 'en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })

  const minNumber = formatter.format(min)
  const maxNumber = formatter.format(max)

  console.error(min, max)

  if (min == 0 && max == 0 && showFreeAsText) {
    return i18n.global.t('common.forFree', {}, { locale }) as string
  }

  if (locale === 'en') {
    return `€ ${minNumber}-${maxNumber}`
  }

  return `${minNumber}-${maxNumber}€`
}

export const isProductCategoryEditable = (
  category?: { cancellationDate?: Date | string | null; expiresAt?: Date | string | null } | null,
) => {
  const cancellationDate = category?.cancellationDate
  const expiresAt = category?.expiresAt
  const now = Date.now()
  const isBeforeCancellation = cancellationDate ? new Date(cancellationDate).getTime() > now : true
  const isBeforeExpiry = expiresAt ? new Date(expiresAt).getTime() > now : true
  return isBeforeCancellation && isBeforeExpiry
}
